import React, { useCallback } from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { Field, GroupField } from "../FieldService";
import FieldInput from "./FieldInput";
import {
	InformationRight,
	ReportFieldRights
} from "core/blueprint/trajectory/TrajectoryBlueprintService";

export type GroupInputProps = {
	labels: Map<string, Array<string>>;
	filter: Array<string>;
	field: GroupField;
	rights: ReportFieldRights;
	editable: boolean;
	onChange: (uuid: string, value: string) => void;
};

const GroupInput: React.FC<GroupInputProps> = (props: GroupInputProps) => {
	function toId(uuid: string): string {
		const separatorIndex = uuid.indexOf("#");
		return separatorIndex === -1 ? uuid : uuid.substring(0, separatorIndex);
	}

	function toCompetenceId(uuid: string): string | null {
		const separatorIndex = uuid.indexOf("#");
		return separatorIndex === -1
			? null
			: uuid.substring(separatorIndex + 1);
	}

	const isShown = useCallback(
		(field: Field) => {
			if (props.filter.length === 0) {
				return true;
			}

			const competenceId = toCompetenceId(field.uuid);
			if (competenceId === null) {
				return true;
			}

			return (
				props.labels
					.get(competenceId)
					?.some(label => props.filter.includes(label)) ?? false
			);
		},
		[props.labels, props.filter]
	);

	return (
		<Grid item>
			<Typography variant="h6">{props.field.name}</Typography>
			<Grid container spacing={1}>
				{props.field.children
					.filter(
						field => props.rights?.[toId(field.uuid)] !== undefined
					)
					.filter(
						field =>
							props.rights[toId(field.uuid)][
								InformationRight.HIDDEN
							] !== true
					)
					.filter(isShown)
					.map(child => (
						<Grid item key={child.uuid} xs={12}>
							<FieldInput
								labels={props.labels}
								filter={props.filter}
								field={child}
								rights={props.rights}
								editable={props.editable}
								onChange={props.onChange}
							/>
						</Grid>
					))}
			</Grid>
		</Grid>
	);
};

export default GroupInput;
